import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  IAuthResponse,
  IPublicBusinessConfig,
} from '@g99-product-web-ui/shared-interface-lib';
import {
  SanitizeService,
  SubjectManageService,
} from '@g99-product-web-ui/shared-service';
import {
  AlertIcon,
  ChevronIcon,
  MoreInfoIcon,
} from '@g99-product-web-ui/shared-util-lib';

import { IProfileMenuItem } from '../../../interfaces/IMenu.interface';
import { ProfileMenuLabel } from '../menu.config';

@Component({
  selector: 'g99-lib-profile-popover-container',
  templateUrl: './profile-popover-container.component.html',
  styleUrl: './profile-popover-container.component.scss',
  animations: [
    trigger('rotate', [
      state('up', style({ transform: 'rotate(0deg)' })),
      state('down', style({ transform: 'rotate(180deg)' })),
      transition('up <=> down', [animate('0.3s ease-in-out')]),
    ]),
  ],
  standalone: false,
})
export class ProfilePopoverContainerComponent {
  @Input() public usersData!: IAuthResponse;
  @Input() public businessData: IPublicBusinessConfig =
    {} as IPublicBusinessConfig;
  @Input() public profileMenus!: IProfileMenuItem[];
  @Input() public userRole!: string;
  @Output() public profileMenuClick = new EventEmitter<{
    route: string;
    label: string;
  }>();

  public arrowState = 'down'; // Arrow state ('up' or 'down')

  public isShowProfileDropdown = false;

  protected notificationIcon!: SafeHtml;
  protected moreInfoIcon!: SafeHtml;
  protected chevronIcon!: SafeHtml;

  constructor(
    private readonly _router: Router,
    private readonly _subjectManagerService: SubjectManageService,
    private readonly _sanitizeService: SanitizeService
  ) {
    this.notificationIcon = this._sanitizeService.sanitizeContent(AlertIcon);
    this.moreInfoIcon = this._sanitizeService.sanitizeContent(MoreInfoIcon);
    this.chevronIcon = this._sanitizeService.sanitizeContent(ChevronIcon);
  }

  // HostListener to close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  protected onClick(event: MouseEvent): void {
    if (this.isShowProfileDropdown) {
      const clickedElement = event.target as HTMLElement;
      const profileDropdown =
        (clickedElement.closest('.profile') as HTMLElement) || null;
      const isClickInside = profileDropdown
        ? profileDropdown.contains(clickedElement)
        : false;

      if (!isClickInside) {
        setTimeout(() => {
          this.arrowState = this.arrowState === 'up' ? 'down' : 'up';
          this.isShowProfileDropdown = !this.isShowProfileDropdown;
        }, 0); // Delay to allow click event to propagate
      }
    }
  }
  // Toggle profile dropdown
  protected toggleProfileDropdown(): void {
    this.arrowState = this.arrowState === 'up' ? 'down' : 'up';
    this.isShowProfileDropdown = !this.isShowProfileDropdown;
  }

  protected onClickProfileMenu(route: string, label: string): void {
    this.isShowProfileDropdown = false;
    this.arrowState = this.arrowState === 'up' ? 'down' : 'up';

    if (label === ProfileMenuLabel.SIGN_OUT || label === 'Sign Out') {
      this._subjectManagerService.logout();
      return;
    }

    if (
      label === ProfileMenuLabel.HELP_CENTER ||
      label === 'Help Center' ||
      label === ProfileMenuLabel.REFER_A_PRACTICE ||
      label === ProfileMenuLabel.SUPPORT_TICKETS
    ) {
      window.open(route, '_blank');
      return;
    }

    this._router.navigate([`${route}`]);
  }
}
